<template>
  <div class="input-wrapper" :style="inputWrapperStyple">
    <input class="input" :style="inputStyple" v-model="value" :type="type" :placeholder="placeholder" @blur="inputBlur" autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" />
    <div v-if="prefixIconSrc" class="prefixWrapper" :style="prefixWrapperStyple">
      <img :style="prefixIconStyple" :src="prefixIconSrc" />
    </div>
    <div v-if="suffixIconSrc" class="suffixWrapper" :style="suffixWrapperStyple">
      <img :style="suffixIconStyple" :src="suffixIconSrc" @click="suffixIconClick" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: String,
      default: '330px'
    },
    height: {
      type: String,
      default: '40px'
    },
    prefixIconWidth: {
      type: String,
      default: '20px'
    },
    prefixIconHeight: {
      type: String,
      default: '20px'
    },
    prefixIconSrc: {
      type: String
    },
    suffixIconWidth: {
      type: String,
      default: '20px'
    },
    suffixIconHeight: {
      type: String,
      default: '20px'
    },
    suffixIconSrc: {
      type: String
    },
    inputValue: {
      type: String
    },
    type: {
      type: String
    },
    placeholder: {
      type: String
    },
    backgroundColor: {
      type: String,
      default: '#ffffff'
    },
    marginLeft: {
      tyoe: String
    },
    marginRight: {
      tyoe: String
    },
    marginTop: {
      tyoe: String
    },
    marginBottom: {
      tyoe: String
    }
  },
  computed: {
    inputWrapperStyple () {
      return {
        marginLeft: this.marginLeft,
        marginRight: this.marginRight,
        marginTop: this.marginTop,
        marginBottom: this.marginBottom
      }
    },
    inputStyple () {
      return {
        width: this.width,
        height: this.height,
        fontSize: this.textSize,
        backgroundColor: this.backgroundColor,
        paddingLeft: this.prefixIconSrc ? this.height : '20px',
        paddingRight: this.suffixIconSrc ? this.height : '20px'
      }
    },
    prefixWrapperStyple () {
      return {
        width: this.height,
        height: this.height
      }
    },
    prefixIconStyple () {
      return {
        width: this.prefixIconWidth,
        height: this.prefixIconHeight
      }
    },
    suffixWrapperStyple () {
      return {
        width: this.height,
        height: this.height
      }
    },
    suffixIconStyple () {
      return {
        width: this.suffixIconWidth,
        height: this.suffixIconHeight
      }
    }
  },
  data () {
    return {
      value: this.inputValue
    }
  },
  methods: {
    suffixIconClick () {
      this.$emit('suffixIconClick')
    },
    inputBlur () {
      this.$emit('inputValue', this.value)
    }
  }
}
</script>
<style scoped>
.input-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}
.input {
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
}
.input::-webkit-input-placeholder {
  color: #aab2bd;
  font-size: 14px;
  text-align: left;
}
.prefixWrapper {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}
.suffixWrapper {
  right: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// third_party/common_app/Common/ZWSComponent/Input.vue